<template>
  <div class="order-tips">温馨提示：出签前请勿提前预定机票酒店！由于近期领馆政策变动较频繁，预计出签时间仅为往常经验参考，实际出签时间可能延迟，请以领事馆或签证中心结果为准。</div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.order-tips{
  padding: 6px 12px;
  background: #FFF6DD;
  border-radius: 2px;
  color: #FF8033;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-tips.vue